// extracted by mini-css-extract-plugin
export default {"container":"src-parts-operations-components-PartsOperationsList-PartsOperationsList__container--Ck6C_"};